module.exports = __webpack_public_path__ + "img/MarsDJNoEventsHere.5f7ece90.png";